module.exports = __webpack_public_path__ + "img/plan-grey-deeper.0ac4c855.svg";